<template>   
    <LayoutSinMenu>        
        <template #contenido>            
            <div class="row">
                <div class="col-12 col-xxl-8 col-xl-8 col-lg-8 col-md-6 col-sm-12 agregar">
                    <p class="titulos-form text-center" type="button" @click="validar"><a-icon type="save" /> {{(edit)?'EDITAR':'AGREGAR'}} UNIDAD</p>
                </div>
                <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                    <img src="images/LOGO.png" width="100%" alt="">
                </div>    
            </div>
            <span v-if="loader">
                <Loading :nuevoTitulo="titulo" />
            </span>
            <span v-else>
                <div class="row">
                    <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <label for="cbi">CBI</label>
                        <input type="text" class="form-control" id="cbi" v-model="unidad.cbi" >
                        <span class="text-danger" v-if="errores">{{ errores.cbi }}</span>
                    </div>
                </div>
                <div class="row">
                    <p class="col-12 text-center subtitulos my-3">UBICACION</p>
                    <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <label for="sede_id">Sede</label>
                        <b-form-select 
                            :options="sedes" 
                            v-model="unidad.sede_id" 
                            id="sede_id"
                            value-field="id"
                            text-field="nombre"
                            @input="getBloques"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.sede_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <label for="sede_id">Bloque / Edificio</label>
                        <b-form-select 
                            :options="bloques" 
                            v-model="unidad.bloque_id" 
                            id="bloque_id"
                            value-field="id"
                            text-field="bloque_edificio"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.bloque_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <label for="piso_id">Piso</label>
                        <b-form-select 
                            :options="pisos" 
                            v-model="unidad.piso_id" 
                            id="piso_id"
                            value-field="id"
                            text-field="piso"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.piso_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <label for="area_especifica">Salón / Area especifica</label>
                        <b-form-input v-model="unidad.area_especifica" id="area_especifica"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.area_especifica }}</span>
                    </div>           
                </div>
                <div class="row">
                    <p class="col-12 text-center subtitulos my-3">ESPECIFICACIONES DEL EQUIPO</p>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="tipo_id">Tipo</label>
                        <b-form-select 
                            :options="tipos" 
                            v-model="unidad.tipo_id" 
                            id="tipo_id"
                            value-field="id"
                            text-field="tipo_equipo"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.tipo_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="capacidade_id">Capacidad BTU</label>
                        <b-form-select 
                            :options="capacidades" 
                            v-model="unidad.capacidade_id" 
                            id="capacidade_id"
                            value-field="id"
                            text-field="capacidad"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.capacidade_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="marca">Marca</label>
                        <b-form-input v-model="unidad.marca" id="marca"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.marca }}</span>
                    </div>    
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="modelo">Modelo</label>
                        <b-form-input v-model="unidad.modelo" id="modelo"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.modelo }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="fecha_adquisicion">Fecha de adquisición</label>
                        <b-form-input type="date" v-model="unidad.fecha_adquisicion" id="fecha_adquisicion"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.fecha_adquisicion }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="fecha_instalacion">Fecha de instalación</label>
                        <b-form-input type="date" v-model="unidad.fecha_instalacion" id="fecha_instalacion"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.fecha_instalacion }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="proveedor">Proveedor</label>
                        <b-form-select 
                            :options="tipo_proveedor" 
                            v-model="unidad.proveedor" 
                            id="proveedor"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.proveedor }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="tiempo_mantenimiento">Tiempo de mantenimiento (horas)</label>
                        <b-form-input
                            type="number"
                            id="tiempo_mantenimiento"
                            v-model.number="unidad.tiempo_mantenimiento"
                            min="0"
                            step="1"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.tiempo_mantenimiento }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="tipo_refrigerante">Tipo de refrigerante</label>
                        <b-form-input v-model="unidad.tipo_refrigerante" id="tipo_refrigerante"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.tipo_refrigerante }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="voltaje_id">Voltaje nominal del equipo</label>
                        <b-form-select 
                            :options="voltajes" 
                            v-model="unidad.voltaje_id" 
                            id="voltaje_id"
                            value-field="id"
                            text-field="voltaje_nominal"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.voltaje_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="tiporede_id">Tipo de red</label>
                        <b-form-select 
                            :options="tiporedes" 
                            v-model="unidad.tiporede_id" 
                            id="tiporede_id"
                            value-field="id"
                            text-field="tipo_red"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.tiporede_id }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="presion_baja">Presion de baja</label>
                        <b-form-input 
                            v-model.number="unidad.presion_baja" 
                            id="presion_baja" 
                            type="number"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.presion_baja }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="corriente_nominal">Corriente nominal del condensador</label>
                        <b-form-input 
                            v-model.number="unidad.corriente_nominal" 
                            id="corriente_nominal" 
                            type="number"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.corriente_nominal }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="corriente_nominal">Corriente nominal del evaporador</label>
                        <b-form-input 
                            v-model.number="unidad.corriente_nominal_evaporador" 
                            id="corriente_nominal_evaporador" 
                            type="number"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.corriente_nominal_evaporador }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="temperatura_operacion">Temperatura de operación</label>
                        <b-form-input 
                            v-model.number="unidad.temperatura_operacion" 
                            id="temperatura_operacion" 
                            type="number"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.temperatura_operacion }}</span>
                    </div>
                    <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label for="nivel_ruido_interiores">Nivel de ruido en interiores</label>
                        <b-form-input 
                            v-model.number="unidad.nivel_ruido_interiores" 
                            id="nivel_ruido_interiores" 
                            type="number"
                            @keydown="allowOnlyNumbers"
                            @input="validateNumberInput"
                            @paste="handlePaste"
                        ></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.nivel_ruido_interiores }}</span>
                    </div>
                    <div class="col-12 my-3 agregar-mobile">
                        <p class="titulos-form text-center" type="button" @click="validar"><a-icon type="save" /> AGREGAR UNIDAD</p>
                    </div>
                </div>
            </span>
        </template>
    </LayoutSinMenu>
</template>
<script>
    import axios from 'axios';
    import LayoutSinMenu from '@/layouts/SinMenu.vue';
    import Loading from '../Loader/Loading.vue';
    
    export default {
        components: {
            LayoutSinMenu, Loading
        },
        props: ['item'],
        data() {
            return {
                bloques: [],
                capacidades: [],
                edit: false,
                errores: null,
                loader: false,
                pisos: [],
                sedes: [],
                titulo: 'Cargando información',
                tipo_proveedor: [
                    {text: 'Interno', value: 'Interno'},
                    {text: 'Externo', value: 'Externo'},
                ],   
                tiporedes: [],
                tipos: [],
                unidad: {cbi: null, bloque_id: null, piso_id: null, area_especifica: null, tipo_id: null, capacidade_id: null, marca: null, modelo: null, fecha_adquisicion: null, tipo_refrigerante: null, voltaje_id: null, tiporede_id: null, presion_baja: null, corriente_nominal: null, temperatura_operacion: null, nivel_ruido_interiores: null, estado_id: 1},
                voltajes: []
            }
        },
        mounted() {
            this.loader = true;
            if(this.$route.params.id){
                this.getUnidad();
                this.edit = true;
            }else if(this.$route.params.cbi){
                this.unidad.cbi = this.$route.params.cbi;
                this.unidad.sede_id = this.$route.params.sede_id;
                this.unidad.bloque_id = this.$route.params.bloque_id;
                this.unidad.tiene_lecturas = 1;
                this.getSedes();
            }else{
                this.unidad.sede_id = this.$route.params.sede_id;
                this.unidad.bloque_id = this.$route.params.bloque_id;
                // this.getData(this.$route.params.id);
                this.getSedes();
            }                   
            this.getPisos();
            this.getTipos();
            this.getCapacidades();
            this.getVoltajes();
            this.getTiporedes();
            
        },
        methods: {
            // ✅ Validaciones para inputs numéricos
            allowOnlyNumbers(event) {
                // Permitir: backspace, delete, tab, escape, enter
                const allowedKeys = [8, 9, 27, 13, 46];
                
                // Permitir: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                if ((event.ctrlKey === true || event.metaKey === true) && 
                    [65, 67, 86, 88].indexOf(event.keyCode) !== -1) {
                    return;
                }
                
                // Permitir: home, end, left, right, down, up
                if ([35, 36, 37, 39, 40, 38].indexOf(event.keyCode) !== -1) {
                    return;
                }
                
                // Permitir: números (0-9) y punto decimal
                if (allowedKeys.indexOf(event.keyCode) !== -1 || 
                    (event.keyCode >= 48 && event.keyCode <= 57) || 
                    (event.keyCode >= 96 && event.keyCode <= 105) || 
                    event.keyCode === 110 || event.keyCode === 190) {
                    return;
                }
                
                // Detener cualquier otro caracter
                event.preventDefault();
            },
            
            validateNumberInput(event) {
                // Validar que event y event.target existan
                if (!event || !event.target) {
                    return;
                }
                
                const target = event.target;
                const value = target.value || '';
                
                // Remover cualquier caracter que no sea número o punto decimal
                const cleanValue = value.replace(/[^0-9.-]/g, '');
                
                // Asegurar que solo haya un punto decimal y un signo negativo al inicio
                let finalValue = cleanValue;
                const hasNegative = cleanValue.startsWith('-');
                const withoutNegative = cleanValue.replace('-', '');
                const parts = withoutNegative.split('.');
                
                if (parts.length > 2) {
                    finalValue = (hasNegative ? '-' : '') + parts[0] + '.' + parts.slice(1).join('');
                } else if (hasNegative && cleanValue.indexOf('-') > 0) {
                    // Solo permitir signo negativo al inicio
                    finalValue = '-' + cleanValue.replace(/-/g, '');
                }
                
                // Actualizar el valor del input solo si cambió
                if (target.value !== finalValue) {
                    target.value = finalValue;
                }
                
                // Actualizar el modelo de datos
                const fieldName = target.id;
                if (fieldName && this.unidad && this.unidad.hasOwnProperty(fieldName)) {
                    this.unidad[fieldName] = finalValue && finalValue !== '-' ? parseFloat(finalValue) : null;
                }
            },
            
            handlePaste(event) {
                // Validar que event y event.target existan
                if (!event || !event.target) {
                    return;
                }
                
                // Prevenir pegar contenido no numérico
                event.preventDefault();
                
                const clipboardData = event.clipboardData || window.clipboardData;
                if (!clipboardData) {
                    return;
                }
                
                const paste = clipboardData.getData('text') || '';
                const numericValue = paste.replace(/[^0-9.-]/g, '');
                
                // Asegurar solo un punto decimal y signo negativo al inicio
                const hasNegative = numericValue.startsWith('-');
                const withoutNegative = numericValue.replace('-', '');
                const parts = withoutNegative.split('.');
                const cleanValue = (hasNegative ? '-' : '') + 
                    (parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : withoutNegative);
                
                if (cleanValue && cleanValue !== '-') {
                    const target = event.target;
                    target.value = cleanValue;
                    
                    const fieldName = target.id;
                    if (fieldName && this.unidad && this.unidad.hasOwnProperty(fieldName)) {
                        this.unidad[fieldName] = parseFloat(cleanValue);
                    }
                    
                    // Disparar evento input para activar otras validaciones
                    const inputEvent = new Event('input', { bubbles: true });
                    target.dispatchEvent(inputEvent);
                }
            },
            
            // ✅ Método para navegar a unidades con página restaurada
            navegarAUnidades(bloqueId) {
                const prevRoute = this.$store.state.prevRoute;
                
                if (prevRoute && 
                    prevRoute.name === 'Unidades' && 
                    prevRoute.params.id === bloqueId &&
                    prevRoute.query && 
                    prevRoute.query.page) {
                    
                    // Navegar con la página restaurada
                    this.$router.push({
                        name: 'Unidades', 
                        params: { id: bloqueId },
                        query: { page: prevRoute.query.page }
                    });
                } else {
                    // Navegación por defecto
                    this.$router.push({name: 'Unidades', params: { id: bloqueId }});
                }
            },
            
            actualizar(){
                this.loader = true;
                this.unidad.cbi = this.unidad.cbi.trim();
                axios.put(`/api/unidades/${this.unidad.id}`, this.unidad, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    console.log(res.data)
                    if(res.data.status === 'errorValidation'){
                        this.errores = res.data.error;
                        this.loader = false;
                    }else{
                        this.loader = false;
                        Swal.fire({
                            icon: 'success',
                            title: 'Unidad actualizada con exito',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: 'Aceptar'
                        }).then((result) => {
                            if(result.value){
                                // ✅ Navegar con página restaurada
                                this.navegarAUnidades(this.$route.params.bloque_id);
                            }
                        })
                    }
                })
                .catch(err => console.log(err))
            },
            getBloques(){
                axios.get(`/api/bloques/${this.unidad.sede_id}` , {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    this.bloques = res.data.bloques;
                })
                .catch(err => console.log(err))
            },
            getCapacidades(){
                axios.get(`/api/capacidades` , {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    this.capacidades = res.data.capacidades;
                })
                .catch(err => console.log(err))
            },
            getData(id){
                axios.get(`/api/unidades/${id}`, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    console.log(res.data)
                })
                .catch(err => console.log(err))
            },  
            getPisos(){
                axios.get('/api/pisos', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.pisos = res.data.pisos;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getSedes(){
                axios.get('/api/sedes', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.sedes = res.data.sedes;
                    this.getBloques();
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getTiporedes(){
                axios.get('/api/tiporedes', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.tiporedes = res.data.tiporedes;
                    this.loader = false;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getTipos(){
                axios.get('/api/tipos', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.tipos = res.data.tipos;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getUnidad(){
                axios.get(`/api/unidades/${this.$route.params.id}`, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                    .then(res => {
                        this.unidad = Object.assign({}, res.data.unidad)
                        this.unidad.sede_id = this.$route.params.sede_id;
                        this.unidad.bloque_id = this.$route.params.bloque_id;
                        this.getSedes();
                    })
                    .catch(err => console.log(err))
            },
            getVoltajes(){
                axios.get('/api/voltajes', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.voltajes = res.data.voltajes;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            guardar(){
                this.loader = true;
                this.unidad.cbi = this.unidad.cbi.trim();
                axios.post('/api/unidades', this.unidad, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    if(res.data.status === 'errorValidation'){
                        this.errores = res.data.error;
                        this.loader = false;
                    }else{
                        this.loader = false;
                        Swal.fire({
                            icon: 'success',
                            title: 'Unidad creada con exito',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: 'Aceptar'
                        }).then((result) => {
                            if(result.value){
                                if(this.$route.params.cbi){
                                    this.$router.push({name: 'GestionCBI'})
                                    return
                                }
                                // ✅ Navegar con página restaurada
                                this.navegarAUnidades(this.$route.params.bloque_id);
                            }
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                    alert('Error al crear la unidad', err)
                    this.loader = false;
                })
            },
            validar(){
                this.titulo = 'Estamos guardando la información';
                if(this.unidad.cbi === null || this.unidad.cbi === '' || this.unidad.cbi === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo CBI no es valido'
                    })
                    return
                }
                if(this.unidad.bloque_id === null || this.unidad.bloque_id === '' || this.unidad.bloque_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo bloque no es valido'
                    })
                    return
                }
                if(this.unidad.piso_id === null || this.unidad.piso_id === '' || this.unidad.piso_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo piso no es valido'
                    })
                    return
                }
                if(this.unidad.area_especifica === null || this.unidad.area_especifica === '' || this.unidad.area_especifica === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo area especifica no es valido'
                    })
                    return
                }
                if(this.unidad.tipo_id === null || this.unidad.tipo_id === '' || this.unidad.tipo_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo tipo no es valido'
                    })
                    return
                }
                if(this.unidad.capacidade_id === null || this.unidad.capacidade_id === '' || this.unidad.capacidade_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo capacidad no es valido'
                    })
                    return
                }
                if(this.unidad.marca === null || this.unidad.marca === '' || this.unidad.marca === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo marca no es valido'
                    })
                    return
                }
                if(this.unidad.modelo === null || this.unidad.modelo === '' || this.unidad.modelo === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo modelo no es valido'
                    })
                    return
                }
                if(this.unidad.fecha_adquisicion === null || this.unidad.fecha_adquisicion === '' || this.unidad.fecha_adquisicion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo fecha no es valido'
                    })
                    return
                }
                if(this.unidad.fecha_instalacion === null || this.unidad.fecha_instalacion === '' || this.unidad.fecha_instalacion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo fecha no es valido'
                    })
                    return
                }
                if(this.unidad.tipo_refrigerante === null || this.unidad.tipo_refrigerante === '' || this.unidad.tipo_refrigerante === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo tipo de refrigerante no es valido'
                    })
                    return
                }
                if(this.unidad.voltaje_id === null || this.unidad.voltaje_id === '' || this.unidad.voltaje_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo voltaje nominal no es valido'
                    })
                    return
                }
                if(this.unidad.tiporede_id === null || this.unidad.tiporede_id === '' || this.unidad.tiporede_id === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo tipo de red no es valido'
                    })
                    return
                }
                if(this.unidad.presion_baja === null || this.unidad.presion_baja === '' || this.unidad.presion_baja === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo presion de baja no es valido'
                    })
                    return
                }
                if(this.unidad.corriente_nominal === null || this.unidad.corriente_nominal === '' || this.unidad.corriente_nominal === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo corriente nominal no es valido'
                    })
                    return
                }
                if(this.unidad.temperatura_operacion === null || this.unidad.temperatura_operacion === '' || this.unidad.temperatura_operacion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo temperatura de operación no es valido'
                    })
                    return
                }
                if(this.unidad.nivel_ruido_interiores === null || this.unidad.nivel_ruido_interiores === '' || this.unidad.nivel_ruido_interiores === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo nivel ruido interiores oque no es valido'
                    })
                    return
                }
                if(this.edit){
                    this.actualizar()
                }else{
                    this.guardar();
                }
            }
        },
    }
</script>
<style scoped>
    .anticon{
        vertical-align: 0 !important;
    }

    .agregar-mobile{
        display: none;
    }

    @media screen and (max-width:768px){
        .agregar-mobile{
            display: block;
        }
        .agregar{
            display: none;
        }
    }
</style>